// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/session/v1/session.proto" (package "agency.session.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * Goal represents the high-level objective extracted from user input.
 *
 * @generated from protobuf message agency.session.v1.Goal
 */
export interface Goal {
    /**
     * description is the goal statement.
     *
     * @generated from protobuf field: string description = 1
     */
    description: string;
    /**
     * confidence is the extraction confidence score (0.0-1.0).
     *
     * @generated from protobuf field: float confidence = 2
     */
    confidence: number;
    /**
     * extracted_at is when the goal was extracted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp extracted_at = 3
     */
    extractedAt?: Timestamp;
    /**
     * reasoning explains how the goal was derived.
     *
     * @generated from protobuf field: string reasoning = 4
     */
    reasoning: string;
}
/**
 * Plan represents the step-by-step execution plan.
 *
 * @generated from protobuf message agency.session.v1.Plan
 */
export interface Plan {
    /**
     * steps are the ordered execution steps.
     *
     * @generated from protobuf field: repeated agency.session.v1.PlanStep steps = 1
     */
    steps: PlanStep[];
    /**
     * confidence is the plan extraction confidence score (0.0-1.0).
     *
     * @generated from protobuf field: float confidence = 2
     */
    confidence: number;
    /**
     * extracted_at is when the plan was extracted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp extracted_at = 3
     */
    extractedAt?: Timestamp;
    /**
     * reasoning explains the planning strategy.
     *
     * @generated from protobuf field: string reasoning = 4
     */
    reasoning: string;
}
/**
 * PlanStep represents a single step in the execution plan.
 *
 * @generated from protobuf message agency.session.v1.PlanStep
 */
export interface PlanStep {
    /**
     * id is the unique step identifier within the plan.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * description explains what this step accomplishes.
     *
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * dependencies are step IDs that must complete before this step.
     *
     * @generated from protobuf field: repeated string dependencies = 3
     */
    dependencies: string[];
    /**
     * required_tools are the tools this step may use.
     *
     * @generated from protobuf field: repeated string required_tools = 4
     */
    requiredTools: string[];
    /**
     * expected_output describes what this step should produce.
     *
     * @generated from protobuf field: string expected_output = 5
     */
    expectedOutput: string;
}
/**
 * Message represents a single message in the conversation.
 *
 * @generated from protobuf message agency.session.v1.Message
 */
export interface Message {
    /**
     * role is the message sender role.
     *
     * @generated from protobuf field: string role = 1
     */
    role: string;
    /**
     * content is the message text content.
     *
     * @generated from protobuf field: string content = 2
     */
    content: string;
    /**
     * thinking_content is the reasoning content (for thinking models).
     *
     * @generated from protobuf field: string thinking_content = 3
     */
    thinkingContent: string;
    /**
     * tool_calls are tool invocations (for assistant messages).
     *
     * @generated from protobuf field: repeated agency.session.v1.ToolCallRef tool_calls = 4
     */
    toolCalls: ToolCallRef[];
    /**
     * tool_call_id links tool result messages to their call.
     *
     * @generated from protobuf field: string tool_call_id = 5
     */
    toolCallId: string;
    /**
     * name is the tool name (for tool result messages).
     *
     * @generated from protobuf field: string name = 6
     */
    name: string;
    /**
     * timestamp is when the message was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 7
     */
    timestamp?: Timestamp;
    /**
     * metadata contains additional message context.
     *
     * @generated from protobuf field: map<string, string> metadata = 8
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * ToolCallRef references a tool call within a message.
 *
 * @generated from protobuf message agency.session.v1.ToolCallRef
 */
export interface ToolCallRef {
    /**
     * id is the tool call identifier.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * name is the tool name.
     *
     * @generated from protobuf field: string name = 2
     */
    name: string;
    /**
     * arguments are the serialized tool arguments (JSON).
     *
     * @generated from protobuf field: string arguments = 3
     */
    arguments: string;
}
/**
 * Fragment represents the conversation context (Cogito primitive).
 *
 * @generated from protobuf message agency.session.v1.Fragment
 */
export interface Fragment {
    /**
     * messages are the conversation messages.
     *
     * @generated from protobuf field: repeated agency.session.v1.Message messages = 1
     */
    messages: Message[];
    /**
     * system_prompt is the system instruction.
     *
     * @generated from protobuf field: string system_prompt = 2
     */
    systemPrompt: string;
    /**
     * metadata contains additional fragment context.
     *
     * @generated from protobuf field: map<string, string> metadata = 3
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * SessionConfig configures session behavior.
 *
 * @generated from protobuf message agency.session.v1.SessionConfig
 */
export interface SessionConfig {
    /**
     * model_id is the LLM model to use.
     *
     * @generated from protobuf field: string model_id = 1
     */
    modelId: string;
    /**
     * max_turns is the maximum conversation turns (0 = unlimited).
     *
     * @generated from protobuf field: int32 max_turns = 2
     */
    maxTurns: number;
    /**
     * max_execution_time_seconds is the session timeout (0 = unlimited).
     *
     * @generated from protobuf field: int32 max_execution_time_seconds = 3
     */
    maxExecutionTimeSeconds: number;
    /**
     * temperature controls LLM randomness (0.0-2.0).
     *
     * @generated from protobuf field: float temperature = 4
     */
    temperature: number;
    /**
     * max_tokens is the maximum response tokens per turn (0 = model default).
     *
     * @generated from protobuf field: int32 max_tokens = 5
     */
    maxTokens: number;
    /**
     * allowed_tools restricts which tools can be used (empty = all allowed).
     *
     * @generated from protobuf field: repeated string allowed_tools = 6
     */
    allowedTools: string[];
    /**
     * thread_id associates this session with a thread (optional).
     *
     * @generated from protobuf field: string thread_id = 7
     */
    threadId: string;
    /**
     * parent_session_id for sub-agent sessions (optional).
     *
     * @generated from protobuf field: string parent_session_id = 8
     */
    parentSessionId: string;
    /**
     * quota_billing_policy determines billing attribution for sub-agents.
     *
     * @generated from protobuf field: string quota_billing_policy = 9
     */
    quotaBillingPolicy: string;
    /**
     * context_window_limit is the maximum context tokens (0 = model default).
     *
     * @generated from protobuf field: int32 context_window_limit = 10
     */
    contextWindowLimit: number;
    /**
     * enable_thinking enables extended thinking for supported models.
     *
     * @generated from protobuf field: bool enable_thinking = 11
     */
    enableThinking: boolean;
    /**
     * snapshot_interval_steps triggers snapshot every N steps (0 = config default).
     *
     * @generated from protobuf field: int32 snapshot_interval_steps = 12
     */
    snapshotIntervalSteps: number;
}
/**
 * SessionState represents the complete session state.
 *
 * @generated from protobuf message agency.session.v1.SessionState
 */
export interface SessionState {
    /**
     * session_id uniquely identifies the session.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * status is the current session state.
     *
     * @generated from protobuf field: agency.session.v1.SessionStatus status = 4
     */
    status: SessionStatus;
    /**
     * config is the session configuration.
     *
     * @generated from protobuf field: agency.session.v1.SessionConfig config = 5
     */
    config?: SessionConfig;
    /**
     * goal is the extracted goal (optional, set after planning).
     *
     * @generated from protobuf field: agency.session.v1.Goal goal = 6
     */
    goal?: Goal;
    /**
     * plan is the execution plan (optional, set after planning).
     *
     * @generated from protobuf field: agency.session.v1.Plan plan = 7
     */
    plan?: Plan;
    /**
     * fragment is the conversation context.
     *
     * @generated from protobuf field: agency.session.v1.Fragment fragment = 8
     */
    fragment?: Fragment;
    /**
     * current_step_index is the index of the currently executing step.
     *
     * @generated from protobuf field: int32 current_step_index = 9
     */
    currentStepIndex: number;
    /**
     * current_turn is the conversation turn count.
     *
     * @generated from protobuf field: int32 current_turn = 10
     */
    currentTurn: number;
    /**
     * created_at is the session creation timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 11
     */
    createdAt?: Timestamp;
    /**
     * updated_at is the last update timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 12
     */
    updatedAt?: Timestamp;
    /**
     * completed_at is the completion timestamp (if status is terminal).
     *
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 13
     */
    completedAt?: Timestamp;
    /**
     * last_snapshot_seq is the stream sequence of the last snapshot.
     *
     * @generated from protobuf field: uint64 last_snapshot_seq = 14
     */
    lastSnapshotSeq: bigint;
    /**
     * tokens_consumed is the total token usage.
     *
     * @generated from protobuf field: int64 tokens_consumed = 15
     */
    tokensConsumed: bigint;
    /**
     * tool_calls_executed is the total tool call count.
     *
     * @generated from protobuf field: int32 tool_calls_executed = 16
     */
    toolCallsExecuted: number;
    /**
     * error_message describes the failure (if status is FAILED).
     *
     * @generated from protobuf field: string error_message = 17
     */
    errorMessage: string;
    /**
     * recovery_mode indicates if this session is recovering from a crash.
     *
     * @generated from protobuf field: bool recovery_mode = 18
     */
    recoveryMode: boolean;
    /**
     * snapshot_reference points to the recovery snapshot (if recovery_mode).
     *
     * @generated from protobuf field: agency.session.v1.SnapshotReference snapshot_reference = 19
     */
    snapshotReference?: SnapshotReference;
}
/**
 * SnapshotReference points to a snapshot for recovery.
 *
 * @generated from protobuf message agency.session.v1.SnapshotReference
 */
export interface SnapshotReference {
    /**
     * snapshot_seq is the stream sequence of the snapshot.
     *
     * @generated from protobuf field: uint64 snapshot_seq = 1
     */
    snapshotSeq: bigint;
    /**
     * storage_location indicates where the snapshot is stored.
     *
     * @generated from protobuf field: agency.session.v1.SnapshotStorageLocation storage_location = 2
     */
    storageLocation: SnapshotStorageLocation;
    /**
     * kv_key is the KV bucket key (if storage_location is KV).
     *
     * @generated from protobuf field: string kv_key = 3
     */
    kvKey: string;
    /**
     * object_store_path is the Object Store path (if storage_location is OBJECT_STORE).
     *
     * @generated from protobuf field: string object_store_path = 4
     */
    objectStorePath: string;
    /**
     * checksum is the snapshot content hash for integrity.
     *
     * @generated from protobuf field: string checksum = 5
     */
    checksum: string;
    /**
     * created_at is when the snapshot was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
}
/**
 * SessionRecoveryRequest requests session state recovery.
 *
 * @generated from protobuf message agency.session.v1.SessionRecoveryRequest
 */
export interface SessionRecoveryRequest {
    /**
     * session_id is the session to recover.
     *
     * @generated from protobuf field: string session_id = 1
     */
    sessionId: string;
    /**
     * tenant is the tenant identifier.
     *
     * @generated from protobuf field: string tenant = 2
     */
    tenant: string;
    /**
     * workspace is the workspace identifier.
     *
     * @generated from protobuf field: string workspace = 3
     */
    workspace: string;
    /**
     * last_known_seq is the last known stream sequence (optional hint).
     *
     * @generated from protobuf field: uint64 last_known_seq = 4
     */
    lastKnownSeq: bigint;
}
/**
 * SessionRecoveryResponse returns the recovered session state.
 *
 * @generated from protobuf message agency.session.v1.SessionRecoveryResponse
 */
export interface SessionRecoveryResponse {
    /**
     * session_state is the recovered state.
     *
     * @generated from protobuf field: agency.session.v1.SessionState session_state = 1
     */
    sessionState?: SessionState;
    /**
     * recovery_source indicates where state was recovered from.
     *
     * @generated from protobuf field: agency.session.v1.SnapshotStorageLocation recovery_source = 2
     */
    recoverySource: SnapshotStorageLocation;
    /**
     * events_replayed is the number of events replayed after snapshot.
     *
     * @generated from protobuf field: int32 events_replayed = 3
     */
    eventsReplayed: number;
    /**
     * recovered_at is when recovery completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp recovered_at = 4
     */
    recoveredAt?: Timestamp;
    /**
     * recovery_duration_ms is the recovery time in milliseconds.
     *
     * @generated from protobuf field: int64 recovery_duration_ms = 5
     */
    recoveryDurationMs: bigint;
}
/**
 * SessionStatus represents the lifecycle state of a session.
 *
 * @generated from protobuf enum agency.session.v1.SessionStatus
 */
export enum SessionStatus {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: SESSION_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * INITIALIZING indicates the session is being created.
     *
     * @generated from protobuf enum value: SESSION_STATUS_INITIALIZING = 1;
     */
    INITIALIZING = 1,
    /**
     * WAITING_CONTEXT indicates waiting for ContextReady signal.
     *
     * @generated from protobuf enum value: SESSION_STATUS_WAITING_CONTEXT = 2;
     */
    WAITING_CONTEXT = 2,
    /**
     * PLANNING indicates the session is extracting goal and plan.
     *
     * @generated from protobuf enum value: SESSION_STATUS_PLANNING = 3;
     */
    PLANNING = 3,
    /**
     * EXECUTING indicates the session is executing steps.
     *
     * @generated from protobuf enum value: SESSION_STATUS_EXECUTING = 4;
     */
    EXECUTING = 4,
    /**
     * PAUSED indicates the session is paused (interrupt).
     *
     * @generated from protobuf enum value: SESSION_STATUS_PAUSED = 5;
     */
    PAUSED = 5,
    /**
     * COMPLETED indicates successful completion.
     *
     * @generated from protobuf enum value: SESSION_STATUS_COMPLETED = 6;
     */
    COMPLETED = 6,
    /**
     * CANCELLED indicates user cancellation.
     *
     * @generated from protobuf enum value: SESSION_STATUS_CANCELLED = 7;
     */
    CANCELLED = 7,
    /**
     * FAILED indicates session failure during execution.
     *
     * @generated from protobuf enum value: SESSION_STATUS_FAILED = 8;
     */
    FAILED = 8,
    /**
     * INITIALIZATION_FAILED indicates session failed to start (context timeout, startup errors).
     *
     * @generated from protobuf enum value: SESSION_STATUS_INITIALIZATION_FAILED = 9;
     */
    INITIALIZATION_FAILED = 9
}
/**
 * SnapshotStorageLocation indicates where snapshots are stored.
 *
 * @generated from protobuf enum agency.session.v1.SnapshotStorageLocation
 */
export enum SnapshotStorageLocation {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: SNAPSHOT_STORAGE_LOCATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * KV stores snapshot inline in KV bucket (small snapshots).
     *
     * @generated from protobuf enum value: SNAPSHOT_STORAGE_LOCATION_KV = 1;
     */
    KV = 1,
    /**
     * OBJECT_STORE stores snapshot in Object Store (large snapshots).
     *
     * @generated from protobuf enum value: SNAPSHOT_STORAGE_LOCATION_OBJECT_STORE = 2;
     */
    OBJECT_STORE = 2,
    /**
     * STREAM stores snapshot as event in session-events stream.
     *
     * @generated from protobuf enum value: SNAPSHOT_STORAGE_LOCATION_STREAM = 3;
     */
    STREAM = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class Goal$Type extends MessageType<Goal> {
    constructor() {
        super("agency.session.v1.Goal", [
            { no: 1, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 2, name: "confidence", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } },
            { no: 3, name: "extracted_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "reasoning", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "8192" } } } }
        ]);
    }
    create(value?: PartialMessage<Goal>): Goal {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.description = "";
        message.confidence = 0;
        message.reasoning = "";
        if (value !== undefined)
            reflectionMergePartial<Goal>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Goal): Goal {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string description */ 1:
                    message.description = reader.string();
                    break;
                case /* float confidence */ 2:
                    message.confidence = reader.float();
                    break;
                case /* google.protobuf.Timestamp extracted_at */ 3:
                    message.extractedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.extractedAt);
                    break;
                case /* string reasoning */ 4:
                    message.reasoning = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Goal, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string description = 1; */
        if (message.description !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.description);
        /* float confidence = 2; */
        if (message.confidence !== 0)
            writer.tag(2, WireType.Bit32).float(message.confidence);
        /* google.protobuf.Timestamp extracted_at = 3; */
        if (message.extractedAt)
            Timestamp.internalBinaryWrite(message.extractedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string reasoning = 4; */
        if (message.reasoning !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reasoning);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.session.v1.Goal
 */
export const Goal = new Goal$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Plan$Type extends MessageType<Plan> {
    constructor() {
        super("agency.session.v1.Plan", [
            { no: 1, name: "steps", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PlanStep, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "100" } } } },
            { no: 2, name: "confidence", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 1, gte: 0 } } } },
            { no: 3, name: "extracted_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "reasoning", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "8192" } } } }
        ]);
    }
    create(value?: PartialMessage<Plan>): Plan {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.steps = [];
        message.confidence = 0;
        message.reasoning = "";
        if (value !== undefined)
            reflectionMergePartial<Plan>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Plan): Plan {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.session.v1.PlanStep steps */ 1:
                    message.steps.push(PlanStep.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* float confidence */ 2:
                    message.confidence = reader.float();
                    break;
                case /* google.protobuf.Timestamp extracted_at */ 3:
                    message.extractedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.extractedAt);
                    break;
                case /* string reasoning */ 4:
                    message.reasoning = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Plan, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.session.v1.PlanStep steps = 1; */
        for (let i = 0; i < message.steps.length; i++)
            PlanStep.internalBinaryWrite(message.steps[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* float confidence = 2; */
        if (message.confidence !== 0)
            writer.tag(2, WireType.Bit32).float(message.confidence);
        /* google.protobuf.Timestamp extracted_at = 3; */
        if (message.extractedAt)
            Timestamp.internalBinaryWrite(message.extractedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string reasoning = 4; */
        if (message.reasoning !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reasoning);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.session.v1.Plan
 */
export const Plan = new Plan$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlanStep$Type extends MessageType<PlanStep> {
    constructor() {
        super("agency.session.v1.PlanStep", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64" } } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "2048" } } } },
            { no: 3, name: "dependencies", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "64" } } } } } },
            { no: 4, name: "required_tools", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "20", items: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } } } },
            { no: 5, name: "expected_output", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } }
        ]);
    }
    create(value?: PartialMessage<PlanStep>): PlanStep {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.description = "";
        message.dependencies = [];
        message.requiredTools = [];
        message.expectedOutput = "";
        if (value !== undefined)
            reflectionMergePartial<PlanStep>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PlanStep): PlanStep {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* repeated string dependencies */ 3:
                    message.dependencies.push(reader.string());
                    break;
                case /* repeated string required_tools */ 4:
                    message.requiredTools.push(reader.string());
                    break;
                case /* string expected_output */ 5:
                    message.expectedOutput = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PlanStep, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* repeated string dependencies = 3; */
        for (let i = 0; i < message.dependencies.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.dependencies[i]);
        /* repeated string required_tools = 4; */
        for (let i = 0; i < message.requiredTools.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.requiredTools[i]);
        /* string expected_output = 5; */
        if (message.expectedOutput !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.expectedOutput);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.session.v1.PlanStep
 */
export const PlanStep = new PlanStep$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Message$Type extends MessageType<Message> {
    constructor() {
        super("agency.session.v1.Message", [
            { no: 1, name: "role", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z][a-z_]*[a-z]$" } } } },
            { no: 2, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1048576" } } } },
            { no: 3, name: "thinking_content", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "1048576" } } } },
            { no: 4, name: "tool_calls", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ToolCallRef, options: { "buf.validate.field": { repeated: { maxItems: "50" } } } },
            { no: 5, name: "tool_call_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128" } } } },
            { no: 6, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9_]*[a-z0-9])?$" } } } },
            { no: 7, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<Message>): Message {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.role = "";
        message.content = "";
        message.thinkingContent = "";
        message.toolCalls = [];
        message.toolCallId = "";
        message.name = "";
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<Message>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Message): Message {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string role */ 1:
                    message.role = reader.string();
                    break;
                case /* string content */ 2:
                    message.content = reader.string();
                    break;
                case /* string thinking_content */ 3:
                    message.thinkingContent = reader.string();
                    break;
                case /* repeated agency.session.v1.ToolCallRef tool_calls */ 4:
                    message.toolCalls.push(ToolCallRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string tool_call_id */ 5:
                    message.toolCallId = reader.string();
                    break;
                case /* string name */ 6:
                    message.name = reader.string();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 7:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* map<string, string> metadata */ 8:
                    this.binaryReadMap8(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap8(map: Message["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Message["metadata"] | undefined, val: Message["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.session.v1.Message.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: Message, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string role = 1; */
        if (message.role !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.role);
        /* string content = 2; */
        if (message.content !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.content);
        /* string thinking_content = 3; */
        if (message.thinkingContent !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.thinkingContent);
        /* repeated agency.session.v1.ToolCallRef tool_calls = 4; */
        for (let i = 0; i < message.toolCalls.length; i++)
            ToolCallRef.internalBinaryWrite(message.toolCalls[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string tool_call_id = 5; */
        if (message.toolCallId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.toolCallId);
        /* string name = 6; */
        if (message.name !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.name);
        /* google.protobuf.Timestamp timestamp = 7; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> metadata = 8; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(8, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.session.v1.Message
 */
export const Message = new Message$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ToolCallRef$Type extends MessageType<ToolCallRef> {
    constructor() {
        super("agency.session.v1.ToolCallRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } },
            { no: 3, name: "arguments", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "65536" } } } }
        ]);
    }
    create(value?: PartialMessage<ToolCallRef>): ToolCallRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.name = "";
        message.arguments = "";
        if (value !== undefined)
            reflectionMergePartial<ToolCallRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ToolCallRef): ToolCallRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string arguments */ 3:
                    message.arguments = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ToolCallRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string arguments = 3; */
        if (message.arguments !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.arguments);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.session.v1.ToolCallRef
 */
export const ToolCallRef = new ToolCallRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Fragment$Type extends MessageType<Fragment> {
    constructor() {
        super("agency.session.v1.Fragment", [
            { no: 1, name: "messages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Message, options: { "buf.validate.field": { repeated: { maxItems: "1000" } } } },
            { no: 2, name: "system_prompt", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "524288" } } } },
            { no: 3, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } }
        ]);
    }
    create(value?: PartialMessage<Fragment>): Fragment {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.messages = [];
        message.systemPrompt = "";
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<Fragment>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Fragment): Fragment {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated agency.session.v1.Message messages */ 1:
                    message.messages.push(Message.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string system_prompt */ 2:
                    message.systemPrompt = reader.string();
                    break;
                case /* map<string, string> metadata */ 3:
                    this.binaryReadMap3(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: Fragment["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Fragment["metadata"] | undefined, val: Fragment["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.session.v1.Fragment.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: Fragment, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated agency.session.v1.Message messages = 1; */
        for (let i = 0; i < message.messages.length; i++)
            Message.internalBinaryWrite(message.messages[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string system_prompt = 2; */
        if (message.systemPrompt !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.systemPrompt);
        /* map<string, string> metadata = 3; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.session.v1.Fragment
 */
export const Fragment = new Fragment$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionConfig$Type extends MessageType<SessionConfig> {
    constructor() {
        super("agency.session.v1.SessionConfig", [
            { no: 1, name: "model_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "max_turns", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 1000, gte: 0 } } } },
            { no: 3, name: "max_execution_time_seconds", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 86400, gte: 0 } } } },
            { no: 4, name: "temperature", kind: "scalar", T: 2 /*ScalarType.FLOAT*/, options: { "buf.validate.field": { float: { lte: 2, gte: 0 } } } },
            { no: 5, name: "max_tokens", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100000, gte: 0 } } } },
            { no: 6, name: "allowed_tools", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { repeated: { maxItems: "100", items: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_]*[a-z0-9]$" } } } } } },
            { no: 7, name: "thread_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 8, name: "parent_session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 9, name: "quota_billing_policy", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^(BILL_INITIATOR|BILL_DELEGATE|BILL_SPLIT)?$" } } } },
            { no: 10, name: "context_window_limit", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 1000000, gte: 0 } } } },
            { no: 11, name: "enable_thinking", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "snapshot_interval_steps", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { lte: 100, gte: 0 } } } }
        ]);
    }
    create(value?: PartialMessage<SessionConfig>): SessionConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.modelId = "";
        message.maxTurns = 0;
        message.maxExecutionTimeSeconds = 0;
        message.temperature = 0;
        message.maxTokens = 0;
        message.allowedTools = [];
        message.threadId = "";
        message.parentSessionId = "";
        message.quotaBillingPolicy = "";
        message.contextWindowLimit = 0;
        message.enableThinking = false;
        message.snapshotIntervalSteps = 0;
        if (value !== undefined)
            reflectionMergePartial<SessionConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionConfig): SessionConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string model_id */ 1:
                    message.modelId = reader.string();
                    break;
                case /* int32 max_turns */ 2:
                    message.maxTurns = reader.int32();
                    break;
                case /* int32 max_execution_time_seconds */ 3:
                    message.maxExecutionTimeSeconds = reader.int32();
                    break;
                case /* float temperature */ 4:
                    message.temperature = reader.float();
                    break;
                case /* int32 max_tokens */ 5:
                    message.maxTokens = reader.int32();
                    break;
                case /* repeated string allowed_tools */ 6:
                    message.allowedTools.push(reader.string());
                    break;
                case /* string thread_id */ 7:
                    message.threadId = reader.string();
                    break;
                case /* string parent_session_id */ 8:
                    message.parentSessionId = reader.string();
                    break;
                case /* string quota_billing_policy */ 9:
                    message.quotaBillingPolicy = reader.string();
                    break;
                case /* int32 context_window_limit */ 10:
                    message.contextWindowLimit = reader.int32();
                    break;
                case /* bool enable_thinking */ 11:
                    message.enableThinking = reader.bool();
                    break;
                case /* int32 snapshot_interval_steps */ 12:
                    message.snapshotIntervalSteps = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string model_id = 1; */
        if (message.modelId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.modelId);
        /* int32 max_turns = 2; */
        if (message.maxTurns !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxTurns);
        /* int32 max_execution_time_seconds = 3; */
        if (message.maxExecutionTimeSeconds !== 0)
            writer.tag(3, WireType.Varint).int32(message.maxExecutionTimeSeconds);
        /* float temperature = 4; */
        if (message.temperature !== 0)
            writer.tag(4, WireType.Bit32).float(message.temperature);
        /* int32 max_tokens = 5; */
        if (message.maxTokens !== 0)
            writer.tag(5, WireType.Varint).int32(message.maxTokens);
        /* repeated string allowed_tools = 6; */
        for (let i = 0; i < message.allowedTools.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.allowedTools[i]);
        /* string thread_id = 7; */
        if (message.threadId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.threadId);
        /* string parent_session_id = 8; */
        if (message.parentSessionId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.parentSessionId);
        /* string quota_billing_policy = 9; */
        if (message.quotaBillingPolicy !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.quotaBillingPolicy);
        /* int32 context_window_limit = 10; */
        if (message.contextWindowLimit !== 0)
            writer.tag(10, WireType.Varint).int32(message.contextWindowLimit);
        /* bool enable_thinking = 11; */
        if (message.enableThinking !== false)
            writer.tag(11, WireType.Varint).bool(message.enableThinking);
        /* int32 snapshot_interval_steps = 12; */
        if (message.snapshotIntervalSteps !== 0)
            writer.tag(12, WireType.Varint).int32(message.snapshotIntervalSteps);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.session.v1.SessionConfig
 */
export const SessionConfig = new SessionConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionState$Type extends MessageType<SessionState> {
    constructor() {
        super("agency.session.v1.SessionState", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "status", kind: "enum", T: () => ["agency.session.v1.SessionStatus", SessionStatus, "SESSION_STATUS_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 5, name: "config", kind: "message", T: () => SessionConfig, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "goal", kind: "message", T: () => Goal },
            { no: 7, name: "plan", kind: "message", T: () => Plan },
            { no: 8, name: "fragment", kind: "message", T: () => Fragment, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "current_step_index", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 10, name: "current_turn", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 11, name: "created_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 12, name: "updated_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 13, name: "completed_at", kind: "message", T: () => Timestamp },
            { no: 14, name: "last_snapshot_seq", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 15, name: "tokens_consumed", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 16, name: "tool_calls_executed", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 17, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "4096" } } } },
            { no: 18, name: "recovery_mode", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "snapshot_reference", kind: "message", T: () => SnapshotReference }
        ]);
    }
    create(value?: PartialMessage<SessionState>): SessionState {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.tenant = "";
        message.workspace = "";
        message.status = 0;
        message.currentStepIndex = 0;
        message.currentTurn = 0;
        message.lastSnapshotSeq = 0n;
        message.tokensConsumed = 0n;
        message.toolCallsExecuted = 0;
        message.errorMessage = "";
        message.recoveryMode = false;
        if (value !== undefined)
            reflectionMergePartial<SessionState>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionState): SessionState {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* agency.session.v1.SessionStatus status */ 4:
                    message.status = reader.int32();
                    break;
                case /* agency.session.v1.SessionConfig config */ 5:
                    message.config = SessionConfig.internalBinaryRead(reader, reader.uint32(), options, message.config);
                    break;
                case /* agency.session.v1.Goal goal */ 6:
                    message.goal = Goal.internalBinaryRead(reader, reader.uint32(), options, message.goal);
                    break;
                case /* agency.session.v1.Plan plan */ 7:
                    message.plan = Plan.internalBinaryRead(reader, reader.uint32(), options, message.plan);
                    break;
                case /* agency.session.v1.Fragment fragment */ 8:
                    message.fragment = Fragment.internalBinaryRead(reader, reader.uint32(), options, message.fragment);
                    break;
                case /* int32 current_step_index */ 9:
                    message.currentStepIndex = reader.int32();
                    break;
                case /* int32 current_turn */ 10:
                    message.currentTurn = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 11:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 12:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 13:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* uint64 last_snapshot_seq */ 14:
                    message.lastSnapshotSeq = reader.uint64().toBigInt();
                    break;
                case /* int64 tokens_consumed */ 15:
                    message.tokensConsumed = reader.int64().toBigInt();
                    break;
                case /* int32 tool_calls_executed */ 16:
                    message.toolCallsExecuted = reader.int32();
                    break;
                case /* string error_message */ 17:
                    message.errorMessage = reader.string();
                    break;
                case /* bool recovery_mode */ 18:
                    message.recoveryMode = reader.bool();
                    break;
                case /* agency.session.v1.SnapshotReference snapshot_reference */ 19:
                    message.snapshotReference = SnapshotReference.internalBinaryRead(reader, reader.uint32(), options, message.snapshotReference);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionState, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* agency.session.v1.SessionStatus status = 4; */
        if (message.status !== 0)
            writer.tag(4, WireType.Varint).int32(message.status);
        /* agency.session.v1.SessionConfig config = 5; */
        if (message.config)
            SessionConfig.internalBinaryWrite(message.config, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* agency.session.v1.Goal goal = 6; */
        if (message.goal)
            Goal.internalBinaryWrite(message.goal, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* agency.session.v1.Plan plan = 7; */
        if (message.plan)
            Plan.internalBinaryWrite(message.plan, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* agency.session.v1.Fragment fragment = 8; */
        if (message.fragment)
            Fragment.internalBinaryWrite(message.fragment, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* int32 current_step_index = 9; */
        if (message.currentStepIndex !== 0)
            writer.tag(9, WireType.Varint).int32(message.currentStepIndex);
        /* int32 current_turn = 10; */
        if (message.currentTurn !== 0)
            writer.tag(10, WireType.Varint).int32(message.currentTurn);
        /* google.protobuf.Timestamp created_at = 11; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 12; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 13; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* uint64 last_snapshot_seq = 14; */
        if (message.lastSnapshotSeq !== 0n)
            writer.tag(14, WireType.Varint).uint64(message.lastSnapshotSeq);
        /* int64 tokens_consumed = 15; */
        if (message.tokensConsumed !== 0n)
            writer.tag(15, WireType.Varint).int64(message.tokensConsumed);
        /* int32 tool_calls_executed = 16; */
        if (message.toolCallsExecuted !== 0)
            writer.tag(16, WireType.Varint).int32(message.toolCallsExecuted);
        /* string error_message = 17; */
        if (message.errorMessage !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.errorMessage);
        /* bool recovery_mode = 18; */
        if (message.recoveryMode !== false)
            writer.tag(18, WireType.Varint).bool(message.recoveryMode);
        /* agency.session.v1.SnapshotReference snapshot_reference = 19; */
        if (message.snapshotReference)
            SnapshotReference.internalBinaryWrite(message.snapshotReference, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.session.v1.SessionState
 */
export const SessionState = new SessionState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SnapshotReference$Type extends MessageType<SnapshotReference> {
    constructor() {
        super("agency.session.v1.SnapshotReference", [
            { no: 1, name: "snapshot_seq", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { uint64: { gte: "1" } } } },
            { no: 2, name: "storage_location", kind: "enum", T: () => ["agency.session.v1.SnapshotStorageLocation", SnapshotStorageLocation, "SNAPSHOT_STORAGE_LOCATION_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "kv_key", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 4, name: "object_store_path", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 5, name: "checksum", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "32", maxLen: "128" } } } },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<SnapshotReference>): SnapshotReference {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.snapshotSeq = 0n;
        message.storageLocation = 0;
        message.kvKey = "";
        message.objectStorePath = "";
        message.checksum = "";
        if (value !== undefined)
            reflectionMergePartial<SnapshotReference>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SnapshotReference): SnapshotReference {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 snapshot_seq */ 1:
                    message.snapshotSeq = reader.uint64().toBigInt();
                    break;
                case /* agency.session.v1.SnapshotStorageLocation storage_location */ 2:
                    message.storageLocation = reader.int32();
                    break;
                case /* string kv_key */ 3:
                    message.kvKey = reader.string();
                    break;
                case /* string object_store_path */ 4:
                    message.objectStorePath = reader.string();
                    break;
                case /* string checksum */ 5:
                    message.checksum = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SnapshotReference, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint64 snapshot_seq = 1; */
        if (message.snapshotSeq !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.snapshotSeq);
        /* agency.session.v1.SnapshotStorageLocation storage_location = 2; */
        if (message.storageLocation !== 0)
            writer.tag(2, WireType.Varint).int32(message.storageLocation);
        /* string kv_key = 3; */
        if (message.kvKey !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.kvKey);
        /* string object_store_path = 4; */
        if (message.objectStorePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.objectStorePath);
        /* string checksum = 5; */
        if (message.checksum !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.checksum);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.session.v1.SnapshotReference
 */
export const SnapshotReference = new SnapshotReference$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionRecoveryRequest$Type extends MessageType<SessionRecoveryRequest> {
    constructor() {
        super("agency.session.v1.SessionRecoveryRequest", [
            { no: 1, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 3, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "64", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 4, name: "last_known_seq", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<SessionRecoveryRequest>): SessionRecoveryRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.sessionId = "";
        message.tenant = "";
        message.workspace = "";
        message.lastKnownSeq = 0n;
        if (value !== undefined)
            reflectionMergePartial<SessionRecoveryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionRecoveryRequest): SessionRecoveryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string session_id */ 1:
                    message.sessionId = reader.string();
                    break;
                case /* string tenant */ 2:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 3:
                    message.workspace = reader.string();
                    break;
                case /* uint64 last_known_seq */ 4:
                    message.lastKnownSeq = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionRecoveryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string session_id = 1; */
        if (message.sessionId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.sessionId);
        /* string tenant = 2; */
        if (message.tenant !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 3; */
        if (message.workspace !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.workspace);
        /* uint64 last_known_seq = 4; */
        if (message.lastKnownSeq !== 0n)
            writer.tag(4, WireType.Varint).uint64(message.lastKnownSeq);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.session.v1.SessionRecoveryRequest
 */
export const SessionRecoveryRequest = new SessionRecoveryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionRecoveryResponse$Type extends MessageType<SessionRecoveryResponse> {
    constructor() {
        super("agency.session.v1.SessionRecoveryResponse", [
            { no: 1, name: "session_state", kind: "message", T: () => SessionState, options: { "buf.validate.field": { required: true } } },
            { no: 2, name: "recovery_source", kind: "enum", T: () => ["agency.session.v1.SnapshotStorageLocation", SnapshotStorageLocation, "SNAPSHOT_STORAGE_LOCATION_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "events_replayed", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 4, name: "recovered_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "recovery_duration_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } }
        ]);
    }
    create(value?: PartialMessage<SessionRecoveryResponse>): SessionRecoveryResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.recoverySource = 0;
        message.eventsReplayed = 0;
        message.recoveryDurationMs = 0n;
        if (value !== undefined)
            reflectionMergePartial<SessionRecoveryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SessionRecoveryResponse): SessionRecoveryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.session.v1.SessionState session_state */ 1:
                    message.sessionState = SessionState.internalBinaryRead(reader, reader.uint32(), options, message.sessionState);
                    break;
                case /* agency.session.v1.SnapshotStorageLocation recovery_source */ 2:
                    message.recoverySource = reader.int32();
                    break;
                case /* int32 events_replayed */ 3:
                    message.eventsReplayed = reader.int32();
                    break;
                case /* google.protobuf.Timestamp recovered_at */ 4:
                    message.recoveredAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.recoveredAt);
                    break;
                case /* int64 recovery_duration_ms */ 5:
                    message.recoveryDurationMs = reader.int64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SessionRecoveryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.session.v1.SessionState session_state = 1; */
        if (message.sessionState)
            SessionState.internalBinaryWrite(message.sessionState, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* agency.session.v1.SnapshotStorageLocation recovery_source = 2; */
        if (message.recoverySource !== 0)
            writer.tag(2, WireType.Varint).int32(message.recoverySource);
        /* int32 events_replayed = 3; */
        if (message.eventsReplayed !== 0)
            writer.tag(3, WireType.Varint).int32(message.eventsReplayed);
        /* google.protobuf.Timestamp recovered_at = 4; */
        if (message.recoveredAt)
            Timestamp.internalBinaryWrite(message.recoveredAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int64 recovery_duration_ms = 5; */
        if (message.recoveryDurationMs !== 0n)
            writer.tag(5, WireType.Varint).int64(message.recoveryDurationMs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.session.v1.SessionRecoveryResponse
 */
export const SessionRecoveryResponse = new SessionRecoveryResponse$Type();
